import { SupabaseClient } from '@supabase/supabase-js';
import { PROJECTS, ProjectKey } from '../config/projects';

export class ProjectFactory {
  /**
   * Obtiene el nombre de tabla para un proyecto específico
   * Siempre usa el nombre original de la tabla y confía en RLS para filtrar por project_id
   */
  static getTableName(table: string, project: ProjectKey): string {
    // Siempre usar el nombre original de la tabla
    // RLS se encarga de filtrar por project_id
    return table;
  }

  /**
   * Obtiene el project_id numérico para un proyecto
   */
  static getProjectId(project: ProjectKey): number {
    const projectIdMap: Record<ProjectKey, number> = {
      '3m': 1,
      'es': 2
    };
    return projectIdMap[project];
  }

  /**
   * Obtiene la configuración de un proyecto
   */
  static getProjectConfig(project: ProjectKey) {
    return PROJECTS[project];
  }

  /**
   * Crea un cliente de Supabase configurado para un proyecto específico
   */
  static createProjectClient(supabase: SupabaseClient, project: ProjectKey) {
    const projectId = ProjectFactory.getProjectId(project);
    
    return {
      from: (table: string) => {
        const tableName = ProjectFactory.getTableName(table, project);
        // No aplicar filtro automático aquí, se aplicará manualmente cuando sea necesario
        return supabase.from(tableName);
      },
      getTableName: (table: string) => ProjectFactory.getTableName(table, project),
      getProject: () => project,
      getProjectConfig: () => ProjectFactory.getProjectConfig(project),
      getProjectId: () => projectId,
      // Método helper para aplicar filtro de proyecto
      withProjectFilter: (queryBuilder: any) => {
        return queryBuilder.eq('project_id', projectId);
      }
    };
  }

  /**
   * Valida que un proyecto existe y está activo
   */
  static validateProject(project: ProjectKey): boolean {
    return project in PROJECTS && PROJECTS[project].isActive;
  }

  /**
   * Obtiene todos los proyectos activos
   */
  static getActiveProjects(): ProjectKey[] {
    return Object.keys(PROJECTS).filter(
      key => PROJECTS[key as ProjectKey].isActive
    ) as ProjectKey[];
  }
}

export type ProjectClient = ReturnType<typeof ProjectFactory.createProjectClient> & {
  withProjectFilter: (queryBuilder: any) => any;
};
